import { createStatsProSlice } from '../statsProSlice';

/**
 * @typedef {StatsProState & {
 *      nav: StatsProNavState & {
 *          playerCount: number,
 *          category: string
 *      }
 * }} StatsLeadersState
 */

/**
 * @type {StatsLeadersState}
 */
const initialState = {
    nav: {
        playerCount: 20,
        category: 'Key Stats'
    }
};

export const statsLeadersSlice = createStatsProSlice({
    name: 'stats-leaders',
    initialState,
    mergeKeys: ['nav']
});

export const statsLeadersReducer = statsLeadersSlice.reducer;
export const statsLeadersActions = statsLeadersSlice.actions;
